/* eslint-disable */
/**
 * Web Sequence Analyzer (WSA)
 * API serving data for the Web Sequence Analyzer (WSA)
 *
 * The version of the OpenAPI document is present in runtime.ts
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Color setting for feature type: I/D/S (Identical/Distinct/Shade)
 * @export
 */
export const SequenceFeatureTypeColorSetting = {
    I: 'I',
    D: 'D',
    S: 'S'
} as const;
export type SequenceFeatureTypeColorSetting = typeof SequenceFeatureTypeColorSetting[keyof typeof SequenceFeatureTypeColorSetting];


export function SequenceFeatureTypeColorSettingFromJSON(json: any): SequenceFeatureTypeColorSetting {
    return SequenceFeatureTypeColorSettingFromJSONTyped(json, false);
}

export function SequenceFeatureTypeColorSettingFromJSONTyped(json: any, ignoreDiscriminator: boolean): SequenceFeatureTypeColorSetting {
    return json as SequenceFeatureTypeColorSetting;
}

export function SequenceFeatureTypeColorSettingToJSON(value?: SequenceFeatureTypeColorSetting | null): any {
    return value as any;
}

